import React from 'react';
import { fileGenerationService } from '../services/file-generation-service';

interface FileDownloadCardProps {
  files: Array<{
    filename: string;
    content: string;
    contentType: string;
    size: number;
  }>;
}

export function FileDownloadCard({ files }: FileDownloadCardProps) {
  if (!files || files.length === 0) return null;

  const handleDownload = (file: any) => {
    try {
      fileGenerationService.downloadFile(file);
    } catch (error) {
      console.error('Erro ao fazer download:', error);
      alert('Erro ao fazer download do arquivo');
    }
  };

  const formatFileSize = (bytes: number): string => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const getFileIcon = (contentType: string) => {
    if (contentType.includes('pdf')) return '📕';
    if (contentType.includes('csv')) return '📊';
    if (contentType.includes('json')) return '📋';
    if (contentType.includes('html')) return '🌐';
    if (contentType.includes('markdown')) return '📝';
    return '📄';
  };

  return (
    <div className="my-4 space-y-2">
      {files.map((file, index) => (
        <div 
          key={index}
          className="border border-gray-200 rounded-lg p-4 bg-gray-50 hover:bg-gray-100 transition-colors"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3 flex-1">
              <span className="text-3xl">{getFileIcon(file.contentType)}</span>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-gray-900 truncate">{file.filename}</p>
                <p className="text-sm text-gray-500">{formatFileSize(file.size)}</p>
              </div>
            </div>
            <button
              onClick={() => handleDownload(file)}
              className="ml-4 flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              <span>Download</span>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

